import styled from 'styled-components';
import { COLOR } from 'assets/styles/colors';
import BREAKPOINT from 'assets/styles/breakpoints';

export const Container = styled.div`
  width: 100%;
  max-width: 616px;
  height: 100%;
  padding: 48px 18px 36px 32px;
  display: flex;
  align-content: center;
  justify-content: center;
  flex-direction: column;
  margin-left: auto;
  margin-right: auto;
`;

export const StageItem = styled.div`
    width: 100%;
    min-height: 80px;
    background: ${({ status }) => (status === 'completed' ? '#F5FAF9' : '#FBFBFB')};
    border: ${({ status }) => (status === 'disabled' ? 'none' : `0.5px solid ${COLOR.GREEN_1}`)};
    box-sizing: border-box;
    box-shadow: 0px 1px 1px rgba(43, 106, 101, 0.3);
    border-radius: 5px;
    padding: 13px 14px 13px 28px;
    margin: 0 0 10px 0;
    display: flex;
    justify-content: space-between;
    /* Desktop */
    @media screen and (min-width: ${BREAKPOINT.LG}) {
      min-height: 96px;
    }
`;

export const BoxText = styled.div`
  width: auto;
  height: 100%;
  position: relative;
  h3 {
        font-weight: 500;
        line-height: 19px;
        display: flex;
        align-items: center;
        color: ${({ status }) => (status === 'disabled' ? `${COLOR.GREY_2}` : `${COLOR.BLUE_1}`)};
    }
    div {
      display: flex;
      flex-wrap: wrap;
    }
    a {
      font-size: 14px;
        /* Tablet-Notebook */
        @media screen and (min-width: ${BREAKPOINT.MD}) {
          font-size: 16px;
        }
        /* Desktop */
        @media screen and (min-width: ${BREAKPOINT.LG}) {
          font-size: 18px;
        }
    }
    p {
        width: 101%;
        margin-top: 6px;
        font-size: 14px;
        line-height: 1.4;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        color: ${({ status }) => (status === 'disabled' ? `${COLOR.GREY_2}` : `${COLOR.GREY_1}`)};

        /* Tablet-Notebook */
        @media screen and (min-width: ${BREAKPOINT.MD}) {
          font-size: 16px;
        }
        /* Desktop */
        @media screen and (min-width: ${BREAKPOINT.LG}) {
          font-size: 18px;
        }
    }
    span {
        position: absolute;
        width: 28px;
        height: 28px;
        border: ${({ status }) => (status === 'disabled' ? `0.5px solid ${COLOR.GREY_2}` : `0.5px solid ${COLOR.GREEN_1}`)};
        border-radius: 50px;
        left: -40px;
        top: 0;
        bottom: 0;
        margin: auto 0;
        z-index: 555;
        background-color: ${({ status }) => (status === 'completed' ? `${COLOR.GREEN_1}` : `${COLOR.WHITE_1}`)};
        font-size: 12px;
        line-height: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: ${({ status }) => (status === 'disabled' ? `${COLOR.GREY_2}` : `${COLOR.GREEN_1}`)};

        /* Tablet-Notebook */
        @media screen and (min-width: ${BREAKPOINT.MD}) {
          font-size: 14px;
        }
        /* Desktop */
        @media screen and (min-width: ${BREAKPOINT.LG}) {
          font-size: 16px;
        }
    }
`;

export const BoxIcons = styled.div`
    width: auto;
    padding: 0;
    display: flex;
    justify-content: ${({ status }) => (status === 'disabled' ? 'space-between' : 'center')};
    align-items: flex-end;
    flex-direction: column;
`;
